import React from 'react';

/** Mismo criterio que emisiones (p. ej. `badge border border-* text-*`): solo borde y texto. */
const StatusGuideBadge = ({ name, txColor, className = '' }) => {
	if (!name) return '-';
	const color = txColor || '#6c757d';
	return (
		<span
			className={`badge fs-12 bg-transparent ${className}`.trim()}
			style={{
				border: `1px solid ${color}`,
				color,
			}}
		>
			{name}
		</span>
	);
};

/** Badge outline con variantes Bootstrap (`border-*` + `text-*`), sin fondo sólido. */
export function OutlineSemanticBadge({ label, variant = 'secondary' }) {
	if (!label) return '-';
	return (
		<span className={`badge fs-12 bg-transparent border border-${variant} text-${variant}`}>
			{label}
		</span>
	);
}

export default StatusGuideBadge;
